export default "__VITE_ASSET__2AshPzbh__"